export default __webpack_public_path__ + "static/media/Read4Fun.a37a65c4.png";